(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('LotController', LotController);

    LotController.$inject = ['$scope', '$state', 'Lot', 'LotMinDTO', 'LotGridDTO', 'ParseLinks', 'AlertService', 'SingleDblClickService', '$uibModal', 'Contract',
                            'LotCustomService', 'ToastrService', 'category','Principal'];

    function LotController ($scope, $state, Lot, LotMinDTO, LotGridDTO, ParseLinks, AlertService, SingleDblClickService, $uibModal, Contract,
                            LotCustomService, ToastrService, category, Principal) {
        var vm = this;

        vm.category = category;
        vm.lots = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.allocate = allocate;
        vm.unallocate = unallocate;
        vm.split = split;

        vm.fieldsMapping = {
            "seller": "seller",
            "purchaseShipment": "purchaseShipment",
            "saleContract": "saleContract",
            "buyer": "buyer",
            "saleShipment": "saleShipment",
            "qtyBales": "qtyBales",
            "lotWeightDisplay": "lotWeightDisplay",
            "growth": "growth",
            "cropYear": "cropYear",
            "lotType": "lotType"
        };

        vm.getLotFieldName = function(dtoName) {
            return vm.fieldsMapping[dtoName] || dtoName;
        };

        vm.gridOptions = {
            paginationPageSizes: [25, 50, 100, 150, 200],
            paginationPageSize: 100,
            enableRowSelection: true,
            enableSelectAll: true,
            enableFiltering: false,
            enableGridMenu: true,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function( gridApi ) {
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = vm.getLotFieldName(sortColumns[0].field);
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Lot', field: 'lotRef', width: 200, visible: true },
                { name: 'Status', field: 'lotStatus', width: 110, visible: true },
                { name: 'Purchase', field: 'purchaseContract', width: 150, visible: true },
                { name: 'Seller', field: 'seller', width: 150, visible: true },
                { name: 'Shipment', field: 'purchaseShipment', width: 150, visible: true },
                { name: 'Sale', field: 'saleContract', width: 150, visible: true },
                { name: 'Buyer', field: 'outsideBuyer', width: 150, visible: true },
                { name: 'Qty', field: 'qtyBales', width: 90, visible: true },
                { name: 'WT', field: 'lotWeightDisplay', width: 120, visible: true },
                { name: 'Growth', field: 'growth', width: 200, visible: true },
                { name: 'CY', field: 'cropYear', width: 90, visible: true },
                { name: 'Type', field: 'lotType', width: 90, visible: true },
                { name: 'Mic', field: 'lotMic', width: 90, visible: true },
                { name: 'Len', field: 'lotLen', width: 90, visible: true },
                { name: 'Str', field: 'lotStr', width: 90, visible: true },
                { name: 'RD+B', field: 'lotRdb', width: 100, visible: true },
                { name: 'S.F.I.', field: 'lotSfi', width: 90, visible: true }
            ]
        };

        // vm.purchaseContracts = [];
        // vm.saleContracts = [];
        // vm.shipments = [];
        // vm.growths = [];
        // vm.buyers = [];
        // vm.sellers = [];
        // vm.purchaseInvoices = [];
        // vm.saleInvoices = [];
        // vm.shipmentBlNumbers = [];
        // vm.shipmentLcNumbers = [];

        initFilter();
        loadAll();
        getPrincipal();

        vm.isAgent = false;
        function getPrincipal() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAgent = vm.account.authorities.includes('ROLE_AGENT');
                // if(!vm.isAgent) initFilterData();
            });
        }

        function initFilterData() {
            // LotCustomService.returnUsedContracts("PURCHASE").then(function (data) {
            //     vm.purchaseContracts = data.data;
            //     vm.purchaseContracts.unshift({id: 0, contractNum: 'Choose a purchase contract'});
            // }, function (error) {
            //     vm.purchaseContracts = [];
            // });
            // LotCustomService.returnUsedContracts("SALE").then(function (data) {
            //     vm.saleContracts = data.data;
            //     vm.saleContracts.unshift({id: 0, contractNum: 'Choose a sale contract'});
            // }, function (error) {
            //     vm.saleContracts = [];
            // });
            // LotCustomService.returnUsedShipments().then(function( data ) {
            //     vm.shipments = data.data;
            //     vm.shipments.unshift({id:0, siNum: 'Choose a shipment'});
            // }, function(error) {
            //     vm.shipments = [];
            // });
            // LotCustomService.returnUsedGrowths().then(function( data ) {
            //     vm.growths = data.data;
            //     vm.growths.unshift({id:0, location: 'Choose a growth'});
            // }, function(error) {
            //     vm.growths = [];
            // });
            // LotCustomService.returnUsedCompanies("BUYER").then( function( data ) {
            //     vm.buyers = data.data;
            //     vm.buyers.unshift({id:0, name: 'Choose a buyer'})
            // }, function(error) {
            //     vm.buyers = [];
            // });
            // LotCustomService.returnUsedCompanies("SELLER").then( function( data ) {
            //     vm.sellers = data.data;
            //     vm.sellers.unshift({id:0, name: 'Choose a seller'})
            // }, function() {
            //     vm.sellers = [];
            // });
            // LotCustomService.returnUsedInvoices("PURCHASE").then( function( data ) {
            //     vm.purchaseInvoices = data.data;
            //     vm.purchaseInvoices.unshift({id:0, invNum: 'Choose a purchase invoice'})
            // }, function( error ) {
            //     vm.purchaseInvoices = [];
            // });
            // LotCustomService.returnUsedInvoices("SALE").then( function( data ) {
            //     vm.saleInvoices = data.data;
            //     vm.saleInvoices.unshift({id:0, invNum: 'Choose a sale invoice'})
            // }, function( error ) {
            //     vm.saleInvoices = [];
            // });
            // LotCustomService.returnUsedShipmentBlNumbers().then( function( data ) {
            //     vm.shipmentBlNumbers = data.data;
            // }, function(error) {
            //     vm.shipmentBlNumbers = [];
            // });
            // LotCustomService.returnUsedShipmentLcNumbers().then( function( data ) {
            //     vm.shipmentLcNumbers = data.data;
            // }, function(error) {
            //     vm.shipmentLcNumbers = [];
            // });
        }

        function initFilter() {
            vm.filterModel = {
                lotRef: '',
                lotType: '',
                cropYear: '',
                qtyBalesFrom: null,
                qtyBalesTo: null,
                purchaseContract: '',
                saleContract: '',
                shipment: '',
                lcNumber: '',
                blNumber: '',
                loadingPlace: '',
                growth: '',
                buyer: '',
                seller: '',
                purchaseInvoice: '',
                saleInvoice: '',
                available: true,
                allocated: true,
                shipped: true
            };
            // vm.filterModel = {
            //     status: '',
            //     cropYear: '',
            //     lotRef: '',
            //     qtyBalesFrom: null,
            //     qtyBalesFTo: null,
            //     type: '',
            //     purchaseContractId: 0,
            //     saleContractId: 0,
            //     loadingPlace: '',
            //     shipmentId: 0,
            //     growthId: 0,
            //     buyerId: 0,
            //     sellerId: 0,
            //     purchaseInvoiceId: 0,
            //     saleInvoiceId: 0,
            //     shipmentLcNumber: '',
            //     shipmentBlNumber: ''
            // };
        }

        function loadAll () {
            if (vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.lots = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            if (vm.category.status && vm.category.status.length > 0) {
                queryParams.status = vm.category.status;
            }
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            LotGridDTO.query(queryParams, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.lots = angular.copy(data);
                vm.gridOptions.data = vm.lots;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                $scope.gridApi.selection.clearSelectedRows();
                ToastrService.success( "Successfully fetched Lots", "Success!");
            }

            function onError(error) {
                AlertService.error(error.data.message);
                ToastrService.error( "Failed to fetch Lots", "Error" );
            }
        }

        function reset () {
            vm.page = 0;
            vm.lots = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        $scope.rowSingleClick = function( row ) {
            SingleDblClickService.singleClick( row, 'lot.lot-detail', 'lot' );
        };

        $scope.rowDblClick = function( row ) {
            if(vm.isAgent) {
                SingleDblClickService.dblClickAgent( row, 'lot.lot-detail', 'lot' );
            } else {
                SingleDblClickService.dblClick( row, 'lot.edit', 'lot' );
            }
        };

        vm.createTab = function( data ) {
            $scope.$emit('handleEmit', data );
        };

        function allocate() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-allocate-modal.html',
                controller: 'LotAllocateModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    myLots: function() {
                        return LotCustomService.returnSelectedLots($scope.gridApi.selection.getSelectedRows());
                    },
                    mySContracts: function() {
                        return Contract.query({type:'SALE'});
                    }
                }
            });
            modalInstance.result.then( function( data ) {
                reset();
            });
        }

        function unallocate() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-unallocate-modal.html',
                controller: 'LotUnallocateModalController',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    myLots: function() {
                        return $scope.gridApi.selection.getSelectedRows();
                    }
                }
            });
            modalInstance.result.then( function( data ) {
                reset();
            });
        }

        function split() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/lot/modal/lot-split-modal.html',
                controller: 'LotSplitModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    myLot: function() {
                        return Lot.get( { id: $scope.gridApi.selection.getSelectedRows()[0].id } ).$promise;
                    }
                }
            });
            modalInstance.result.then( function( data ) {
                reset();
            });
        }

        vm.cleanFilter = function() {
            initFilter();
            vm.reset();
        };
    }
})();
